import React, { useCallback } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Container } from '@material-ui/core';
import { CONTRATO_ETAPAS_PARAMS_URL, URL_ENTE_DESCENTRALIZADO, VersaoContratoEnum } from 'models/contratos';
import { loadContratoAssessor } from 'store/modules/ContratosFluxoDescentralizado/Assessores/AssessoresActions';
import { loadContratoEntePublico } from 'store/modules/ContratosFluxoDescentralizado/EntePublico/EntePublicoActions';
import { loadContratoEntePrivado } from 'store/modules/ContratosFluxoDescentralizado/EntePrivado/EntePrivadoActions';
import { loadCidadesByEstadoId } from 'store/modules/LogradouroActions';
import { ContratoStepItem } from './ContratoStepItem';
import useContratoDescentralizadoStep from 'pages/Contratos/Fluxos/FluxoDescentralizados/hooks/useContratoDescentralizadoStep';
import './index.scss';

export const ContratoStep = ({ items, renderForm, navigateToStep }) => {
  const currentStepContrato = useSelector(
    (state) => state.allContratos.currentContratoStep
  );
  const logradouro = useSelector((state) => state.logradouro);
  const contratosEntePublicoReducer = useSelector((state) => state.contratosDescentralizadosEntePublico);
  const location = useLocation();
  const { getItemContratoIndex } = useContratoDescentralizadoStep();
  const params = useParams();
  const id = params.id;
  const dispatch = useDispatch();

  const fluxoAssessor = location.pathname.includes(URL_ENTE_DESCENTRALIZADO.ASSESSOR);
  const fluxoEntePublico = location.pathname.includes(URL_ENTE_DESCENTRALIZADO.ENTE_PUBLICO);
  const fluxoEntePrivado = location.pathname.includes(URL_ENTE_DESCENTRALIZADO.ENTE_PRIVADO);

  const getUFByIdEstado = useCallback((idEstadoParam) => {
    const estadoV = logradouro.estados.find((estado) => estado.id === idEstadoParam);
    return estadoV ? estadoV.sigla : '';
  }, [logradouro.estados]);

  const loadEstadosAll = useCallback(() => {
    loadCidades(contratosEntePublicoReducer.contratoEditing.idEstado);
    // eslint-disable-next-line
  }, [contratosEntePublicoReducer.contratoEditing.idEstado]);

  const getCidades = useCallback((uf) => {
    if (!uf) {
      return [];
    }
    return logradouro.cidades[uf.toLowerCase()] || [];
  }, [logradouro.cidades]);

  const loadCidades = useCallback((idEstado) => {
    const uf = getUFByIdEstado(idEstado);
    if (uf && getCidades(uf).length === 0) {
      dispatch(loadCidadesByEstadoId(idEstado, uf));
    }
  }, [dispatch, getUFByIdEstado, getCidades]);

  const verificaFluxo = useCallback((IdParam) => {
    if (location.pathname.includes(CONTRATO_ETAPAS_PARAMS_URL.CADASTRO)) {
      return;
    } else {
      switch (true) {
        case fluxoEntePublico:
          loadEstadosAll();
          dispatch(loadContratoEntePublico(id, VersaoContratoEnum.CONTRATO));
          break;
        case fluxoEntePrivado:
          dispatch(loadContratoEntePrivado(id, VersaoContratoEnum.CONTRATO));
          break;
        case fluxoAssessor:
          dispatch(loadContratoAssessor(id, VersaoContratoEnum.CONTRATO));
          break;
        default:
          break;
      }
      navigateToStep(IdParam);
    }
  }, [location.pathname, fluxoEntePublico, fluxoEntePrivado, fluxoAssessor, loadEstadosAll, dispatch, id, navigateToStep]);

  return (
    <Container style={{ padding: 0 }}>
      <Box className='contrato-box'>
        <Box className='contrato-box-item'>
          {items.map((item, index) => (
            <React.Fragment key={item.id}>
              <ContratoStepItem
                id={item.id}
                icon={item.icon}
                isActive={item.id === currentStepContrato}
                isCompleted={index < getItemContratoIndex(items)}
                label={item.label}
                onClick={() => verificaFluxo(item.id)}
              />
              {index < items.length - 1 && (
                <Box className='contrato-container-line'>
                  <Box
                    className={`contrato-line ${index < getItemContratoIndex(items) ? 'contrato-active-line' : ''}`}
                  />
                </Box>
              )}
            </React.Fragment>
          ))}
        </Box>
        {renderForm(currentStepContrato)}
      </Box>
    </Container>
  );
};